import React from 'react';
import toast, { ToastPosition } from 'react-hot-toast';

interface ToastOptions {
  duration?: number;
  position?: ToastPosition;
  id?: string;
}

const defaultOptions: ToastOptions = {
  // We're never automatically hiding toasts to meet timing adjustable accessibility rules
  // In the future, we can remove this if users have the ability to customise toast settings, including turning them off, adjusting the duration, or extending the time limits
  duration: Infinity,
  position: 'bottom-center',
};

const createToast = (component: any, options: ToastOptions = {}) => {
  const toastOptions = { ...defaultOptions, ...options };
  toast.custom(
    (toast) =>
      React.cloneElement(component, {
        toastId: toast.id,
        visible: toast.visible,
      }),
    toastOptions
  );
};

export const dismissToast = toast.dismiss;

export default createToast;
